import type { ReactNode } from 'react'

/** "Saved" beside a field, announced politely. Shown after a save until the
 * person types again. */
export function SavedNote({ show }: { show: boolean }): ReactNode {
  return (
    <span role="status" className="text-xs text-bed-good">
      {show ? 'Saved' : ''}
    </span>
  )
}
